import React from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox } from '@mui/material';

const campoEstilos = { marginBottom: '10px' };

const CampoDinamico = ({ campo, manejarSeleccion, index ,componentesDisponibles }) => {
    // Maneja la lógica específica para algunos tipos de campo
    const renderCampoEspecifico = () => {
        switch (campo.tipo) {
            case 'select':
                return (
                    <FormControl variant="outlined" style={campoEstilos} required={campo.requerido} fullWidth>
                        <InputLabel>{campo.label}</InputLabel>
                        <Select onChange={(e) => manejarSeleccion(e, index)}>
                            {campo.opciones.map((opcion, idx) => (
                                <MenuItem value={opcion} key={idx}>
                                    {opcion}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            case 'checkbox':
                return (
                    <FormControlLabel
                        control={<Checkbox name={campo.label} />}
                        label={campo.label}
                    />
                );
            case 'dependencia':
                if (campo.nombreComponente && componentesDisponibles[campo.nombreComponente]) {
                    const ComponenteSeleccionado = componentesDisponibles[campo.nombreComponente];
                    return <ComponenteSeleccionado etiqueta={campo.label} {...campo.otrasProps} />;
                }
                break;
                
            default:
                return (
                    <TextField
                        label={campo.label}
                        variant="outlined"
                        style={campoEstilos}
                        required={campo.requerido}
                        fullWidth
                        type={campo.tipo === 'correo' ? 'email' : campo.tipo === 'date' ? 'date' : 'text'}
                        InputLabelProps={campo.tipo === 'date' ? { shrink: true } : undefined}
                        inputProps={
                            campo.tipo === 'numero'
                                ? {
                                    pattern: "\\d*",
                                    maxLength: campo.digitosLimite,
                                    }
                                : campo.tipo === 'decimal'
                                ? { pattern: "\\d*\\.?\\d*" }
                                : undefined
                        }
                    />
                );
        }
    };

    return renderCampoEspecifico();
};

export default CampoDinamico;
